import { useId } from 'react';

interface OfflineIconProps {
  size?: number;
  className?: string;
}

// Wifi symbol struck through: the arcs are concentric around the dot, and the mask punches a gap
// around the slash so it cuts them cleanly instead of just overlapping. The arcs are concentric
// around the dot at (12, 19.4) — radii 13 / 8.7 / 4.4, each spanning ±52°, so the four levels sit an
// even 4.3 units apart. useId keeps the mask id unique when several icons are on the page.
const OfflineIcon: React.FC<OfflineIconProps> = ({ size = 16, className }) => {
  const maskId = `offlineIconCut${useId().replace(/:/g, '')}`;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
      <mask id={maskId}>
        <rect width="24" height="24" fill="#fff" />
        <line x1="3.5" y1="3.5" x2="20.5" y2="20.5" stroke="#000" strokeWidth="5" strokeLinecap="round" />
      </mask>
      <g mask={`url(#${maskId})`} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
        <path d="M1.76 11.39a13 13 0 0 1 20.48 0" />
        <path d="M5.14 14.04a8.7 8.7 0 0 1 13.72 0" />
        <path d="M8.53 16.69a4.4 4.4 0 0 1 6.94 0" />
        <circle cx="12" cy="19.4" r="1.2" fill="currentColor" stroke="none" />
      </g>
      <line x1="3.5" y1="3.5" x2="20.5" y2="20.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
    </svg>
  );
};

export default OfflineIcon;
